export default __webpack_public_path__ + "static/media/landing_banner.f5136bb8.jpg";